import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import React, { useState, useEffect, useRef } from 'react'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { GlobalVariables } from 'Globals/GlobalVariables'
import data from '../../assets/data.json'
import dataMenu from '../../assets/dataMenu.json'
import playButton from '../../assets/play-button.svg'
import TVGuide from 'components/TVGuide'
import MenuOnePager from 'components/MenuOnePager'
import { useWindowSize } from 'usehooks-ts'
import { useInView } from 'react-intersection-observer'

const debug = window.document.title === 'TA-Interaktiv Microfrontend'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const [selectedPartei, setSelectedPartei] = useState<string>('')
  const [selectedColor, setSelectedColor] = useState<string>('')
  const [updatedPartyInView, setUpdatedPartyInView] = useState<string>('')

  var part = properties?.part || 0
  var defaultParty = properties?.defaultParty || 'Grüne'

  const tvGuideRef = useRef<HTMLDivElement | null>(null)
  const menuRef = useRef<HTMLDivElement | null>(null)
  const [menuHeight, setMenuHeight] = useState(0)

  /* Start */
  const [windowHeight, setWindowHeight] = useState(0)
  const { width, height } = useWindowSize()

  const [heightWindow, setHeight] = useState(0)
  const [initialHeight, setInitialHeight] = useState(0)
  const [headerheight, setHeaderHeight] = useState(0)

  const readHeaderHeight = () => {
    const headerElement = document.querySelector('[class*=FullHeader_root]')

    let headerheight = 0
    if (headerElement) {
      // check if header is sticky
      const headerStyle = window.getComputedStyle(headerElement)
      const isSticky =
        headerStyle.position === 'sticky' && headerStyle.top <= '0px'

      if (isSticky) {
        headerheight = headerElement.clientHeight
        setHeaderHeight(headerheight)
      } else {
        setHeaderHeight(0)
      }
    }
  }

  useEffect(() => {
    readHeaderHeight()
    setInitialHeight(window.innerHeight - headerheight)
    // setup resize listener
    const handleResize = () => {
      setHeight(window.innerHeight - headerheight)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    window.addEventListener('scroll', (event) => {
      readHeaderHeight()
    })
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [headerheight])

  useEffect(() => {
    setWindowHeight(window.innerHeight)
  }, [])

  /* Ende */
  const handlePartyUpdate = (party: string) => {
    setUpdatedPartyInView(party)
  }

  return (
    <AppContainer $colorMode={colorMode}>
      {(part === 'TVGuide' || debug) && (
        <TextWidth>
          <TVGuideContainer>
            <Wrapper>
              <img src={playButton} alt='Icon Play' />
              <h3>TV-Programm</h3>
            </Wrapper>
            <MenuOnePager
              defaultValue={defaultParty}
              data={dataMenu}
              ref={menuRef}
              updatedPartyInView={updatedPartyInView}
              onClick={(partei: string, color: string) => {
                setSelectedPartei(partei)
                setSelectedColor(color)
                const selectedPartyContainer =
                  tvGuideRef.current?.querySelector('#' + partei)
                if (menuRef.current && selectedPartyContainer) {
                  const newMenuHeight =
                    menuRef.current.getBoundingClientRect().height
                  setMenuHeight(newMenuHeight)
                  const rect = selectedPartyContainer.getBoundingClientRect()
                  window.scrollTo({
                    top: rect.top + window.scrollY - newMenuHeight - headerheight,
                    behavior: 'smooth',
                  })
                }
              }}
              headerheight={headerheight}
            ></MenuOnePager>
            <TVGuide
              ref={tvGuideRef}
              data={data}
              partei={selectedPartei}
              color={selectedColor}
              colorMode={colorMode}
              headerheight={headerheight}
              menuHeight={menuHeight}
              partyInViewUpdate={handlePartyUpdate}
            />
          </TVGuideContainer>
        </TextWidth>
      )}
    </AppContainer>
  )
}

const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`
const Wrapper = styled.div`
  background-color: #242424;
  color: var(--gray-5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5em;
  border-bottom: 1px solid #121212;

  @media only screen and (max-width: 711px) {
    padding: 1.25em;
  }
  img {
    max-width: 40px;
    margin-right: 1em;
    @media only screen and (max-width: 711px) {
      max-width: 35px;
    }
  }
  h3 {
    margin: 0;
    font-size: 1.5em;
    font-weight: 600;
    text-align: center;

    @media only screen and (max-width: 711px) {
      font-size: 1.25em;
    }
  }
`
const TVGuideContainer = styled.div`
  margin-bottom: 6rem;
  @media only screen and (max-width: 711px) {
    margin-bottom: 4rem;
  }
`

export default MainComponent
